import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { styles } from './styles'
import { makeStyles } from '@material-ui/styles'
import { CONFIG } from '../../../../Config/config'
import { PATHS } from '../../../../Config/Routing/paths'
import Tooltip from '@material-ui/core/Tooltip'
import { authorization } from '../../../../Module/Auth/Auth'
import { apiClient } from '../../../../Module/API/Client'
import { userLogout } from '../../../../Reducers/Auth/actions'
import { ConfirmationModal } from '../../../../Components/Modal/ConfirmationModal/ConfirmationModal'

const socialProviders = {
  Google: {
    title: 'Google',
    param: 'GoogleMerge',
  },
}

export const SocialLink = ({ type, user }) => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()
  const dispatch = useDispatch()
  const provider = socialProviders[type]
  const { title, param } = provider
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const hasPassword = user.hasPassword
  const hasGoogleAccount = user.hasGoogleAccountAssigned

  const handleSocialAuth = () => {
    const width = 500
    const height = 500
    const left = window.innerWidth / 2 - width / 2
    const top = window.innerHeight / 2 - height / 2

    window.open(
      `${CONFIG.API_BASE_URL}/auth/${title.toLowerCase()}/${user.email}/merge`,
      param,
      `width=${width},height=${height},scrollbars=yes,resizable=yes,left=${left},top=${top}`,
    )
  }

  const handleDisconnect = async () => {
    setLoading(true)
    try {
      await apiClient.disconnectOAuth2Provider({
        userId: user.id,
        providerType: title.toLowerCase(),
      })
      dispatch(userLogout())
      authorization.logout()
      window.location.href = PATHS.main.login
    } catch (error) {
      console.error('Error disconnecting social provider:', error)
    } finally {
      setTimeout(() => setLoading(false), 2000)
    }
  }

  const handleButtonClick = () => {
    if (hasGoogleAccount) {
      setIsModalOpen(true)
    } else {
      handleSocialAuth()
    }
  }

  const handleConfirmDisconnect = async () => {
    await handleDisconnect()
    setIsModalOpen(false)
  }

  return (
    <div className={classes.securityItem}>
      <div className={classes.connectContainer}>
        <p className={classes.buttonLabel}>{title}</p>
        <p className={classes.connectLabel}>
          {hasGoogleAccount ? 'Connected' : 'Disconnected'}
        </p>
      </div>
      {hasPassword ? (
        <button
          className={classes.securityButton}
          onClick={handleButtonClick}
          disabled={loading}
        >
          {hasGoogleAccount ? 'Disconnect' : 'Connect'}
        </button>
      ) : (
        <Tooltip
          title="Create a password before disconnecting."
          classes={{ tooltip: classes.tooltip }}
        >
          <span>
            <button className={classes.securityButtonDisabled} disabled>
              {hasGoogleAccount ? 'Disconnect' : 'Connect'}
            </button>
          </span>
        </Tooltip>
      )}

      {isModalOpen && (
        <ConfirmationModal
          title="Are you sure?"
          text="For security reasons, you'll be logged out if you disconnect."
          returnText="Cancel"
          submitText="Disconnect"
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleConfirmDisconnect}
          loading={loading}
        />
      )}
    </div>
  )
}
